import axios from "axios";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../store/authMethods";
import store from "../store/index";

const API = axios.create({
  baseURL: "https://ccubicle.s3.amazonaws.com",
  //   baseURL: process.env.REACT_APP_AWS,
  timeout: 30000,
  retry: 1,
  retryDelay: 1000,
  headers: {
    "Content-type": "multipart/form-data",
    // "Content-type": "image/png",
  },
});

API.interceptors.request.use(
  function (config) {
    // console.log(config, "config");
    const token = localStorage.getItem("token");
    // config.headers.Authorization = token ? `Bearer ${token}` : "";
    return config;
  },
  function (error) {
    // console.log(error, "error");
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
API.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Unauthorized
    // console.log(error, "error");
    if (error.response?.status === 401) {
      store.dispatch(logout());
      setTimeout(() => {
        // navigate("/");
        window.location.href = "?action=login";
      }, 1500);

      // store.dispatch(setMessage(error.response.data.Message));
      // setTimeout(() => {
      //   store.dispatch(logoutUser());
      // }, 3000);
    }
    // if (error.response?.status === 500) {
    //   // store.dispatch(logout());
    //   setTimeout(() => {
    //     // navigate("/");
    //     window.location.href = "?action=login";
    //   }, 1000);
    // }

    return Promise.reject(error);
  }
);

export default API;
